var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_290_257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.59961V19.1996C0 19.8361 0.252856 20.4466 0.702944 20.8967C1.15303 21.3468 1.76348 21.5996 2.4 21.5996H21.6C22.2365 21.5996 22.847 21.3468 23.2971 20.8967C23.7471 20.4466 24 19.8361 24 19.1996V9.59961L12 14.3996L0 9.59961Z",
    fill: "#009EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4 2.40039C1.76348 2.40039 1.15303 2.65325 0.702944 3.10333C0.252856 3.55342 0 4.16387 0 4.80039L0 7.20039L12 12.0004L24 7.20039V4.80039C24 4.16387 23.7471 3.55342 23.2971 3.10333C22.847 2.65325 22.2365 2.40039 21.6 2.40039H2.4Z",
    fill: "#009EF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.29ba56f87aabb89913eefae8104cee67.svg";
export { ForwardRef as ReactComponent };